module.exports = __webpack_public_path__ + "img/credits.8816b5fe.png";